import styled from 'styled-components';

export const Layout = styled.div<{ error: boolean }>(({ theme, error }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: error ? theme.designSystem.colors.red['000'] : 'transparent',
}));
